var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.313 20.635c5.664 0 10.312-4.658 10.312-10.323C20.625 4.659 15.967 0 10.312 0 4.649 0 0 4.658 0 10.313c0 5.664 4.658 10.322 10.313 10.322Zm.01-15.655c.663 0 1.171.45 1.171 1.094v4.336l-.127 2.031.762-1.045 1.025-1.113a.977.977 0 0 1 .752-.342c.596 0 1.016.41 1.016.987 0 .302-.088.527-.313.771l-3.33 3.467c-.273.293-.576.44-.957.44-.38 0-.674-.137-.947-.44l-3.34-3.467c-.224-.244-.312-.469-.312-.771 0-.576.42-.987 1.015-.987.293 0 .576.127.752.342l1.035 1.143.743 1.006-.118-2.022V6.074c0-.644.508-1.094 1.172-1.094Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.02c84d688d38dcdc2b088a84e2d0c4bc.svg";
export { ForwardRef as ReactComponent };